export type SupportedLanguage = 'pt-BR' | 'pt-PT' | 'en' | 'es';

export type TrendsCountry =
  | 'world'
  | 'brazil'
  | 'portugal'
  | 'spain'
  | 'mexico'
  | 'colombia'
  | 'peru'
  | 'chile'
  | 'argentina';

function getBrowserLocales(): string[] {
  if (typeof navigator === 'undefined') return [];
  const list = [...(navigator.languages || []), navigator.language];
  return list
    .filter(Boolean)
    .map(value => value.replace('_', '-').toLowerCase());
}

function normalizeAccountLocale(language?: string): string | undefined {
  if (!language) return undefined;
  return language.toString().replace('_', '-').toLowerCase();
}

function matchLanguage(value: string): SupportedLanguage | undefined {
  if (value === 'pt-br') return 'pt-BR';
  if (value === 'pt-pt' || value === 'pt') return 'pt-PT';
  if (value.startsWith('pt')) return 'pt-BR';
  if (value.startsWith('es')) return 'es';
  if (value.startsWith('en')) return 'en';
  return undefined;
}

function matchTrendsCountry(value: string): TrendsCountry | undefined {
  if (value.startsWith('pt-br')) return 'brazil';
  if (value === 'pt-pt' || value === 'pt') return 'portugal';
  if (value.startsWith('pt')) return 'brazil';
  if (value.startsWith('es-mx')) return 'mexico';
  if (value.startsWith('es-co')) return 'colombia';
  if (value.startsWith('es-pe')) return 'peru';
  if (value.startsWith('es-cl')) return 'chile';
  if (value.startsWith('es-ar')) return 'argentina';
  if (value.startsWith('es')) return 'spain';
  if (value.startsWith('en')) return 'world';
  return undefined;
}

export function resolveLanguage(accountLanguage?: string): SupportedLanguage {
  const account = normalizeAccountLocale(accountLanguage);
  if (account) {
    const fromAccount = matchLanguage(account);
    if (fromAccount) return fromAccount;
  }

  for (const value of getBrowserLocales()) {
    const match = matchLanguage(value);
    if (match) return match;
  }

  return 'en';
}

export function resolveTrendsCountry(accountLanguage?: string): TrendsCountry {
  const account = normalizeAccountLocale(accountLanguage);
  if (account) {
    const fromAccount = matchTrendsCountry(account);
    if (fromAccount) return fromAccount;
  }

  for (const value of getBrowserLocales()) {
    const match = matchTrendsCountry(value);
    if (match) return match;
  }

  return 'world';
}
